import React, { useState } from 'react';
import { AppBar, Toolbar, Box, IconButton, Typography, Container, Link as MuiLink, Drawer, List, ListItem, ListItemButton, ListItemText, Divider, Stack } from '@mui/material';
import { Link, useLocation } from 'react-router-dom';
import GitHubIcon from '@mui/icons-material/GitHub';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import InstagramIcon from '@mui/icons-material/Instagram';
import usePortfolioStore from '../store/portfolioStore.js';
import useUIStore from '../store/uiStore.js';
import DarkModeIcon from '@mui/icons-material/DarkMode';
import LightModeIcon from '@mui/icons-material/LightMode';
import MenuIcon from '@mui/icons-material/Menu';
import CloseIcon from '@mui/icons-material/Close';
import { motion } from 'framer-motion';

export default function Layout({ children }) {
  const { pathname } = useLocation();
  const contacts = usePortfolioStore((s) => s.contacts);
  const mode = useUIStore((s) => s.mode);
  const toggleMode = useUIStore((s) => s.toggleMode);
  const [open, setOpen] = useState(false);
  const nav = ['/', '/about', '/projects', '/skills', '/testimonials', '/contact'];
  const close = () => setOpen(false);
  return (
    <Box minHeight="100vh" display="flex" flexDirection="column">
      <AppBar position="sticky" color="transparent" elevation={0} sx={{ backdropFilter: 'blur(8px)', borderBottom: '1px solid rgba(255,255,255,0.06)' }}>
        <Container maxWidth={false}>
          <Toolbar disableGutters>
            <Typography variant="h6" sx={{ flexGrow: 1 }}>
              <MuiLink component={Link} to="/" underline="none" color="inherit">Mesum.dev</MuiLink>
            </Typography>
            <Box sx={{ display: { xs: 'none', md: 'flex' }, alignItems: 'center' }}>
              {nav.map((p) => (
                <MuiLink key={p} component={Link} to={p} underline={pathname === p ? 'always' : 'hover'} color="inherit" sx={{ mx: 1.5 }}>
                  {p === '/' ? 'Home' : p.replace('/', '').replace(/^[a-z]/, (m) => m.toUpperCase())}
                </MuiLink>
              ))}
              <IconButton onClick={toggleMode} color="inherit" aria-label="Toggle theme" sx={{ mx: 0.5 }}>
                {mode === 'dark' ? <LightModeIcon /> : <DarkModeIcon />}
              </IconButton>
              <IconButton href="https://github.com/mesumbinshaukat" target="_blank" rel="noreferrer" color="inherit"><GitHubIcon /></IconButton>
              <IconButton href="https://www.linkedin.com/in/mesum-bin-shaukat/" target="_blank" rel="noreferrer" color="inherit"><LinkedInIcon /></IconButton>
              <IconButton href="http://instagram.com/mesum.dev" target="_blank" rel="noreferrer" color="inherit"><InstagramIcon /></IconButton>
            </Box>
            <Box sx={{ display: { xs: 'flex', md: 'none' }, alignItems: 'center', gap: 0.5 }}>
              <IconButton onClick={toggleMode} color="inherit" aria-label="Toggle theme" sx={{ mx: 0.5 }}>
                {mode === 'dark' ? <LightModeIcon /> : <DarkModeIcon />}
              </IconButton>
              <IconButton aria-label="Open menu" onClick={() => setOpen(true)} color="inherit">
                <MenuIcon />
              </IconButton>
            </Box>
          </Toolbar>
        </Container>
      </AppBar>
      <Drawer anchor="right" open={open} onClose={close} PaperProps={{ sx: { width: 300, backgroundColor: 'background.paper' } }}>
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', px: 2, py: 1 }}>
          <Typography variant="h6">Menu</Typography>
          <IconButton aria-label="Close menu" onClick={close}><CloseIcon /></IconButton>
        </Box>
        <Divider sx={{ opacity: .2 }} />
        <List>
          {nav.map((p, i) => (
            <motion.div key={p} initial={{ opacity: 0, x: 20 }} animate={{ opacity: 1, x: 0 }} transition={{ delay: 0.03 * i }}>
              <ListItem disablePadding>
                <ListItemButton component={Link} to={p} selected={pathname === p} onClick={close}>
                  <ListItemText primaryTypographyProps={{ fontWeight: pathname === p ? 700 : 500 }} primary={p === '/' ? 'Home' : p.replace('/', '').replace(/^[a-z]/, m => m.toUpperCase())} />
                </ListItemButton>
              </ListItem>
            </motion.div>
          ))}
        </List>
        <Divider sx={{ opacity: .2 }} />
        <Box sx={{ p: 2 }}>
          <Typography variant="overline" sx={{ opacity: .8 }}>Social</Typography>
          <Stack direction="row" spacing={1} sx={{ mt: 1 }}>
            <IconButton href="https://github.com/mesumbinshaukat" target="_blank" rel="noreferrer" color="inherit"><GitHubIcon /></IconButton>
            <IconButton href="https://www.linkedin.com/in/mesum-bin-shaukat/" target="_blank" rel="noreferrer" color="inherit"><LinkedInIcon /></IconButton>
            <IconButton href="http://instagram.com/mesum.dev" target="_blank" rel="noreferrer" color="inherit"><InstagramIcon /></IconButton>
          </Stack>
        </Box>
      </Drawer>
      <Container maxWidth={false} sx={{ flex: 1, py: 4 }}>
        {children}
      </Container>
      <Box component="footer" sx={{ py: 3, textAlign: 'center', opacity: .8 }}>
        <Typography variant="body2">WhatsApp: {contacts.whatsapp} · Email: {contacts.email}</Typography>
      </Box>
    </Box>
  );
}


